<template>
    <MainContent title="Crear campo">
        <template v-slot:header>
            <h3 class="card-title">Crear campo</h3>
        </template>
        <template v-slot:content v-if="!loading">
            <FormComponent :campo="campo" @terminado="crearCampo()" @recargar="recargar()" :key="reloadComponent"/>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormComponent from '@/components/backend/formularios/FormComponent';

    export default {
        data() {
            return {
                loading: false,
                campo: {
                    filters: {},
                    name: '',
                    type: '',
                    required: false,
                    options: [
                        {
                            name: '',
                            value: ''
                        },
                        {
                            name: '',
                            value: ''
                        }
                    ]
                },
                reloadComponent: 1
            }
        },
        methods: {
            crearCampo() {
                this.loading = true;

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.forms.create'), this.campo).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.formularios.index' });
                }).catch(error => {
                    this.$toast.error('Ha ocurrido un error');
                }).finally(() => {
                    this.loading = false;
                });
            },
            recargar() {
                this.reloadComponent += 1;
            }
        },
        components: {
            MainContent, FormComponent
        }
    }
</script>
